module.exports = __webpack_public_path__ + "static/c1-ae0fd5f62b1d109378cc30bf7e8fa22d.png";